//文字滚动
function roll(name) {
    var $this = $(name);
    var scrollTimer;
    $this.hover(function() {
        clearInterval(scrollTimer);
    }, function() {
        scrollTimer = setInterval(function() {
            scrollNews($this);
        }, 3000);
    }).trigger("mouseleave");
}
function scrollNews(obj) {
    var $self = obj.find("ul:first");
    var lineHeight = $self.find("li:first").height();
    $self.animate({ "marginTop": -lineHeight + "px" }, 1600, function() {
        $self.css({ marginTop: 0 }).find("li:first").appendTo($self);
    })
}
roll(".winning_content"); //评论滚动


//抽奖弹窗
window.popup=function (name) {
    $(".mask").height($(document).height());
    $(".popup h2").eq(name).show();
    $(".popup ,.mask").show();
    $(".popup .close ,.icon-sure").click(function() {
        $(".popup ,.mask ,.popup h2").hide()
    });

}



